import Uploader from './Uploader';

class RepositoryUploader extends Uploader {
  constructor(props) {
    super(props);
    this.shared = props.shared;
    this.apiClient = props.apiClient;
  }

  getUploadRequestParams = (node, ctx) => {
    return this.apiClient.post('/storage/objects', {
      name: node.file.name,
      container: ctx ? ctx.container : undefined,
      shared: this.shared,
    }).then((res) => {
      const url = res.headers.location;
      const index = url.lastIndexOf('/');
      const id = index >= 0 ? url.substring(index + 1) : url;
      node.id = id;
      return {
        url: `${url}/content`,
        method: 'PUT',
      };
    });
  }

  nodeUploaded(node) {
    return this.apiClient.post(`/storage/objects/${node.id}/content`)
        .then(() => { node.closed = true; });
  }

  nodeUploadFailed(node) {
    return this.apiClient.post(`/storage/objects/${node.id}/content`)
      .then(() => {
        return this.apiClient.delete(`/storage/objects/${node.id}`);
      }).finally(() => {
        node.id = null;
      });
  }
}

export default RepositoryUploader;
